import React from 'react'
import PropTypes from 'prop-types'
import { Badge } from 'reactstrap'
import MarketproductSingleVariantField from 'domains/seller-market-product/molecules/single-variant-field'
import Collapsible from 'components/molecules/collapsible'

const propTypes = {
  variants         : PropTypes.array,
  arrayHelpers     : PropTypes.object,
  measurementProps : PropTypes.object,
  disabledFields   : PropTypes.object
}

/**
 * Multi variant field
 * @param {array} variants - Formik value variants
 * @param {object} arrayHelpers - Formik field array helper
 * @param {bool} disabledFields - consist of disabled fields
 * @param {object} measurementProps - Measurement props. contain
 *   - parentName
 *   - productSize
 *   - measurementAttributes
 */
const SellerMarketProductMultipleVariantField = ({
  variants,
  arrayHelpers,
  disabledFields,
  ...measurementProps
}) => variants.map((_variant, index) => (
  <Collapsible
    key={ index }
    isOpen={ true }
    header={ `Variant - ${index + 1}` }
  >
    <div className="d-flex justify-content-end">
      {
        !disabledFields?.removeVariant
          ?
          (
            <Badge
              onClick={ () => arrayHelpers.remove(index) }
              style={{
                color  : '#f28ca9',
                cursor : 'pointer'
              }}
            >
              Remove <i className="far fa-times-circle"></i>
            </Badge>
          )
          : null
      }
    </div>
    <MarketproductSingleVariantField
      { ...measurementProps }
      disabledFields={ disabledFields }
      fieldIndex={ index }
    />
  </Collapsible>
))

SellerMarketProductMultipleVariantField.propTypes = propTypes

export default SellerMarketProductMultipleVariantField
